/**
 * Created by previousdeveloper on 14.11.2015.
 */
export * from './lib/countdown';


// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/~/angular2-simple-countdown/countdown.ts